import React from 'react'

export default function Container9() {
  return (
    <div className='container cont9 text-center  my-5'>
        <video loop muted autoPlay controls = '' id='video' className='w-100 mx-0 text-center vd' >
            <source src='./video.mp4' type='video/mp4'/>
        </video>
        <div class="overlayText bg-white text-center mx-auto  d-flex px-5 py-3">
    <span id="topText" className='text-dark overlaytextp'><span className='overlaytexthd ' id='toptext1'>Echte Erfolge</span><br></br>
    “Für unsere Werkstatt hat sich mit PiiSCREEN die Tür zu regionalem Erfolg und mehr Wachstum geöffnet.”</span>
    
  </div>
    </div>
  )
}
